import service from '@/utils/request.js'
export function selectSheetInfo() {
	return service.request({
		method: 'get',
		url: '/teacher/controller/teacherselectbookinfo/listSemesters',
	});
}
export function selectSampleBook() {
	return service.request({
		method: 'get',
		url: '/SampleBook/selectSampleBook',
	});
}

export function getBookDetail(sampleBookId) {
	return service.request({
		method: 'get',
		url: `/SampleBook/selectSampleBook/${sampleBookId}`,
	});
}
export function selectProvinceSchool(province) {
	return service.request({
		method: 'get',
		url: `/teacherCertification/selectProvinceSchool/${province}`,
	});
}

export function selectSchoolFaculty(schoolId) {
	return service.request({
		method: 'get',
		url: `/teacherCertification/selectSchoolFaculty/${schoolId}`,
	});
}

export function selectFacultyMajor(facultyId) {
	return service.request({
		method: 'get',
		url: `/teacherCertification/selectFacultyMajor/${facultyId}`,
	});
}
export function addTeacherCertification(data) {
	return service.request({
		method: 'post',
		url: '/teacherCertification/addTeacherCertification',
		data: data
	});
}
export function myMessage() {
	return service.request({
		method: 'get',
		url: '/front/login/myMessage',
	});
}
